"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const localForage = require("localforage");
const model_1 = require("./model");
const cacheInstances = {};
/**
 * Initializes a cache instance for a specific business domain.
 *
 * @param {string} name
 * @returns {Cache}
 */
exports.init = (name) => {
    const cacheInstance = localForage.createInstance({
        driver: localForage.LOCALSTORAGE,
        name
    });
    cacheInstances[name] = cacheInstance;
    return cacheInstance;
};
/**
 * Returns existing cache instance or creates a new one.
 *
 * @param {string} name
 * @returns {ICache | void}
 */
exports.getCacheInstance = (name) => {
    if (cacheInstances && cacheInstances[name]) {
        return cacheInstances[name];
    }
    return exports.init(name);
};
exports.cacheRepoObj = (cacheType) => {
    return {
        get: (cacheKey) => {
            return exports.getCacheInstance(cacheType).getItem(cacheKey)
                .then((result) => {
                return result.data;
            });
        },
        setData: ((cacheKey, data) => {
            return exports.getCacheInstance(cacheType).setItem(cacheKey, data);
        })
    };
};
exports.clearUserCache = () => __awaiter(void 0, void 0, void 0, function* () {
    exports.getCacheInstance(model_1.CacheType.USER).dropInstance();
    exports.getCacheInstance(model_1.CacheType.DEAL).dropInstance();
    exports.getCacheInstance(model_1.CacheType.DEALER).dropInstance();
    exports.getCacheInstance(model_1.CacheType.FINANCE).dropInstance();
});
//# sourceMappingURL=index.js.map